export const fromOutgrow = window.location.pathname.startsWith("/chat");

export default function getEnv() {
  switch (window.location.hostname) {
    case "localhost":
      return {
        ENVIRONMENT: "development",
        isAI: false,
        SERVER_API_URL:
          import.meta.env.VITE_SERVER_API_URL || "http://localhost:4000",
        PUBLIC_DOMAIN: "localhost",
        PAGE_DOMAIN: "localhost",
      };
    case "ai.localhost":
      return {
        ENVIRONMENT: "development",
        isAI: true,
        SERVER_API_URL:
          import.meta.env.VITE_SERVER_API_URL || "http://localhost:4000",
        PUBLIC_DOMAIN: "ai.localhost",
        PAGE_DOMAIN: "ai.localhost",
      };
    case "live.outgrow.chat":
      return {
        ENVIRONMENT: "staging",
        isAI: false,
        SERVER_API_URL: "https://api.outgrow.chat",
        PUBLIC_DOMAIN: "live.outgrow.chat",
        PAGE_DOMAIN: "omniengage.co",
      };
    case "liveai.outgrow.chat":
      return {
        ENVIRONMENT: "staging",
        isAI: true,
        SERVER_API_URL: "https://api.outgrow.chat",
        PUBLIC_DOMAIN: "liveai.outgrow.chat",
        PAGE_DOMAIN: "chatbotbuilder.net",
      };
    case "live-release.outgrow.chat":
      return {
        ENVIRONMENT: "pre-production",
        isAI: true,
        SERVER_API_URL: "https://api-release.outgrow.chat",
        PUBLIC_DOMAIN: "live-release.outgrow.chat",
        PAGE_DOMAIN: "chatbotbuilder.net",
      };
  }

  if (window.location.hostname.endsWith(".omniengage.co")) {
    return {
      ENVIRONMENT: "production",
      isAI: false,
      SERVER_API_URL: "https://api.omniengage.co",
      PUBLIC_DOMAIN: "app.omniengage.co",
      PAGE_DOMAIN: "omniengage.co",
    };
  }

  if (window.location.hostname.endsWith(".chatbotbuilder.net")) {
    return {
      ENVIRONMENT: "production",
      isAI: true,
      SERVER_API_URL: "https://api.chatbotbuilder.net",
      PUBLIC_DOMAIN: "app.chatbotbuilder.net",
      PAGE_DOMAIN: "chatbotbuilder.net",
    };
  }

  return {
    ENVIRONMENT: "production",
    isAI: true,
    SERVER_API_URL: fromOutgrow
      ? "https://live-api.outgrow.chat"
      : "https://api.chatbotbuilder.net",
    PUBLIC_DOMAIN: "app.chatbotbuilder.net",
    PAGE_DOMAIN: "chatbotbuilder.net",
  };
}
